var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGroup20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 49,
    viewBox: "0 0 61 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7331 48.1168H0V23.8857H16.7331V48.1168ZM1.57266 46.5433H15.1605V25.4592H1.57266V46.5433Z",
    fill: "#209BB7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7505 48.1168H22.0173V15.1689H38.7505V48.1168ZM23.59 46.5434H37.1778V16.7424H23.59V46.5434Z",
    fill: "#209BB7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.7676 48.1159H44.0344V0H60.7676V48.1159ZM45.6071 46.5424H59.1949V1.57344H45.6071V46.5424Z",
    fill: "#209BB7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5064 28.9194H1.06934V30.4929H15.5064V28.9194Z",
    fill: "#209BB7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5864 20.4243H23.1494V21.9978H37.5864V20.4243Z",
    fill: "#209BB7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M59.824 6.16797H45.387V7.74141H59.824V6.16797Z",
    fill: "#209BB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup20);
export default __webpack_public_path__ + "static/media/Group20.e33eab007740dc675cbf8cef041d572d.svg";
export { ForwardRef as ReactComponent };